import React from 'react';
import Header from './components/Header';
import {OnBoardingContextProvider} from '../../context/onBoarding/OnBoardingContextProvider';

interface LayoutProps {
  children: React.ReactNode;
}

function OnBoardingLayout({children}: LayoutProps) {
  return (
    <OnBoardingContextProvider>
      <div className="flex flex-col h-screen">
        <Header />

        <div className="flex-1 flex flex-col overflow-hidden">{children}</div>
      </div>
    </OnBoardingContextProvider>
  );
}

export default OnBoardingLayout;
